import React, { useState, useEffect } from 'react';
import { FormLabel, FormGroup, FormControl } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import Mousetrap from 'mousetrap';
import { ClipLoader } from 'react-spinners';
import LoadingPage from '../LoadingPage';
import ApiService from '../../services/ApiService';
import FlatButton from './FlatButton';

// const binRegex = /^[A-Z]:[A-Z.#*0-9/-]+$/; ?
// const listName = 'PIM12U';

let good = null;

const BinPane = props => {
  const { initialValue, updateValue, validationCallback } = props;
  const [value, setValue] = useState(initialValue || '');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [loadingBins, setLoadingBins] = useState(false);
  const [suggested, setSuggested] = useState([]);
  const [velocity, setVelocity] = useState([]);
  const [recent, setRecent] = useState([]);

  const originalKey = Mousetrap.prototype.handleKey;

  const clear = () => {
    setValue('');
  };

  const validate = item => {
    if (loading) {
      return;
    }

    if (value !== item) {
      setValue(item);
    }
    setLoading(true);

    validationCallback(item).then(() => {
      good = item;
      setLoading(false);
      updateValue(item);
    });
  };

  const onChange = event => {
    setValue(event.target.value);
  };

  const onBlur = () => {
    // validate(value);
  };

  const onKeyPress = event => {
    if (event.key === 'Enter') {
      validate(value);
    }
  };

  const handleBinKey = key => {
    setValue(val => `${val}${key}`);
  };

  const handleKey = (char, m, e) => {
    if (e.type === 'keydown') {
      if (e.key === 'Tab' || e.key === 'Enter') {
        validate(value);
        return;
      }
    }

    if (e.type === 'keypress') {
      if (e.target.tagName !== 'INPUT') {
        handleBinKey(e.key);
      }
    }
  };

  const getBinList = () => {
    setLoadingBins(true);
    ApiService.get('part/bins').then(response => {
      const { bins, recent, velocity } = response.data;
      if (bins.length) {
        setSuggested(bins.slice(0, 5).map(item => (item.bin === '' ? '<Unmarked>' : item.bin)));
      }

      if (recent.length) {
        setRecent(recent);
      }

      // const { vbins, velocity } = response.data;
      if (velocity.length) {
        setVelocity(velocity.slice(0, 35).map(item => (item.bin === '' ? '<Unmarked>' : item.bin)));
      }

      setLoadingBins(false);
    });
  };

  const random = () => {
    ApiService.get('part/bins/random').then(response => {
      const bin = response.data;
      validate(bin);
    });
  };

  useEffect(() => {
    Mousetrap.prototype.handleKey = handleKey;

    return () => {
      Mousetrap.prototype.handleKey = originalKey;
    };
  });

  useEffect(() => {
    setMessage('');
  }, [value]);

  useEffect(() => {
    getBinList();
  }, []);

  const clearClassName = classNames({
    'clear-button': true,
    disabled: value === '' || loading,
  });

  const listClassName = classNames({
    lists: true,
    loading,
  });

  const checkClassName = classNames({
    check: true,
    primary: good !== value,
    disabled: loading || good === value,
    good: good === value,
  });

  const checkLabel = good === value ? <i className="fas fa-check-circle" /> : 'Check';

  return (
    <>
      <div className="entry">
        <FormLabel>Scan or Enter Bin</FormLabel>
        <FormGroup>
          <FormControl onChange={onChange} onBlur={onBlur} onKeyPress={onKeyPress} value={value} />
          {(value.length || loading !== false) && (
            <div className="loading">
              <FlatButton className={checkClassName} onClick={() => validate(value)}>
                {loading ? <ClipLoader sizeUnit="px" size={12} width={2} color="#fff" /> : checkLabel}
              </FlatButton>
            </div>
          )}
          {message !== '' && <div className="message">{message}</div>}
        </FormGroup>
        <div className="input-controls">
          <FlatButton onClick={random}>Random</FlatButton>
          <FlatButton className={clearClassName} onClick={clear}>
            Clear
          </FlatButton>
        </div>
      </div>
      <div className={listClassName}>
        <div className="bin-lists">
          {recent.length !== 0 && (
            <div className="recent-wrapper">
              <div className="recent">
                <div className="recent-head">Recent</div>
                <div className="recent-body">
                  {recent.map(item => {
                    return (
                      <div className="recent-item" key={item} onClick={() => validate(item)}>
                        {item}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
          <div className="recent-wrapper">
            <div className="recent">
              <div className="recent-head">Oldest</div>
              <div className="recent-body">
                {loadingBins === true ? (
                  <LoadingPage />
                ) : (
                  <>
                    {suggested.map(item => {
                      return (
                        <div className="recent-item" key={item} onClick={() => validate(item)}>
                          {item}
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="recent-wrapper">
            <div className="recent">
              <div className="recent-head">Velocity</div>
              <div className="recent-body">
                {loadingBins === true ? (
                  <LoadingPage />
                ) : (
                  <>
                    {velocity.map(item => {
                      return (
                        <div className="recent-item" key={item} onClick={() => validate(item)}>
                          {item}
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </>
  );
};

BinPane.defaultProps = {
  initialValue: '',
  updateValue: () => {},
};

BinPane.propTypes = {
  initialValue: PropTypes.string,
  updateValue: PropTypes.func,
  validationCallback: PropTypes.func,
};

export default BinPane;
